export default type => ({ payload, onError, callback, ...rest }) => ({
  type,
  payload,
  onError,
  callback,
  ...rest,
})
